import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import _ from 'lodash';
import queryString from 'query-string';

import InventoryList from '../../components/reports/InventoryList';
import Spinner from '../../components/generics/Spinner';
import ReportHeader from '../../components/generics/ReportHeader';
import Filter from '../../components/generics/Filter';

import {
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
  fetchLocations,
  fetchLocationsSuccess,
  fetchLocationsFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
} from "../../store/inventories/actions";

import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";
import { fetchInventories, fetchInventoriesSuccess, fetchInventoriesFailure } from "../../store/reports/actions";

import { getItems, getItem } from "../../store/inventories/api";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class InventoryListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      isLoadingSearch: false,
      selectedItem: undefined,
      selectedStation: undefined,
      selectedBrand: undefined,
      selectedGrade: undefined,
      filterFrom: undefined,
      selectedPlant: '',
      selectedLot: '',
      selectedLocation: '',
    }

    this.loadSearchOptions = _.debounce(this.searchItems, DEBOUNCE_SEARCH);

    this.changeSearch = _.debounce(() => {
      this.updateResults();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const selectedItem = params.item ? { value: params.item } : undefined;
    const selectedStation = params.station ? params.station : undefined;
    const selectedBrand = params.brand ? params.brand : undefined;
    const selectedGrade = params.grade ? params.grade : this.state.selectedGrade;
    const currentPage = params.page ? params.page : STARTING_PAGE;
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;
    const selectedLocation = params.location ? params.location : this.state.selectedLocation;

    // Fetch initial page
    this.setState({
      currentPage, selectedItem, selectedStation, selectedBrand,
      filterFrom, selectedPlant, selectedLot, selectedLocation, selectedGrade
    }, () => {
      this.props.fetchInventories(
        currentPage,
        selectedItem ? selectedItem.value : undefined,
        selectedStation,
        selectedBrand,
        filterFrom,
        selectedPlant,
        selectedLot,
        selectedLocation,
        selectedGrade
      );
    });

    // Fetch stations
    if (!this.props.stationsList.stations || this.props.stationsList.stations.length === 0) {
      this.props.fetchStations();
    }
    // Fetch brands
    if (!this.props.brandsList.brands || this.props.brandsList.brands.length === 0) {
      this.props.fetchBrands();
    }
    // Fetch locations
    if (!this.props.locationsList.locations || this.props.locationsList.locations.length === 0) {
      this.props.fetchLocations();
    }

    // Fetch grades
    if (!this.props.gradesList.grades || this.props.gradesList.grades.length === 0) {
      this.props.fetchGrades();
    }

    if (selectedItem) {
      getItem(selectedItem.value).then((res) => {
        this.setState({selectedItem: {value: selectedItem.value, label: res.data.name}});
      })
    }
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------
  updateResults = () => {
    const { selectedItem, selectedStation, selectedBrand, filterFrom, currentPage, selectedPlant, selectedLot, selectedLocation, selectedGrade } = this.state;
    this.props.fetchInventories(
      currentPage,
      selectedItem ? selectedItem.value : undefined,
      selectedStation,
      selectedBrand,
      filterFrom,
      selectedPlant,
      selectedLot,
      selectedLocation,
      selectedGrade
    );
    let params = {};
    if (selectedItem) params.item = selectedItem.value;
    if (selectedStation) params.station = selectedStation;
    if (selectedBrand) params.brand = selectedBrand;
    if (filterFrom) params.from = filterFrom;
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    if (selectedLocation) params.location = selectedLocation;
    if (selectedGrade) params.grade = selectedGrade;
    params.page = currentPage;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  onSearchChange = (item) => {
     let selectedItem = item ? item : undefined;
     this.setState({ selectedItem, currentPage: STARTING_PAGE }, () => {
       this.updateResults();
     });
   };

  onFromDateChange = (event) => {
    let filterFrom = event.target.value;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  searchItems = (input, callback) => {
    this.setState({isLoadingItems: true});
    let options = [];
    getItems(input).then((res) => {
      res.data.results.map((item) => {
        options.push({value:item.id, label:item.name});
        return true;
      });
      callback(options);
      this.setState({isLoadingItems: false, selectedItem: this.state.selectedItem});
    }).catch((err) => {
      this.setState({isLoadingItems: false});
    });
  };

  onStationChange = (event) => {
    let selectedStation = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedStation, currentPage: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  onBrandChange = (event) => {
    let selectedBrand = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedBrand, currentPage: STARTING_PAGE }, () => {
      this.updateResults();
    });
  };

  onGradeChange = (event) => {
    let selectedGrade = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedGrade, currentPage: STARTING_PAGE }, () => {
      this.changeSearch();
    });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  onLocationChange = (event) => {
    const selectedLocation = event.target.value && parseInt(event.target.value, 10) !== -1 ? event.target.value : "";
    this.setState({ selectedLocation }, () => {
      this.changeSearch();
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          this.updateResults();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ReportHeader title='Active inventory items' hideAction={true}/>
          <Filter
            searchDropdownLabel="Search Item"
            searchDropdownPlaceholder="Search item"
            searchDropdownVal={this.state.selectedItem}
            onSearchDropdownChange={this.onSearchChange}
            isLoadingSearchDropdown={this.state.isLoadingSearch}
            loadSearchDropdownOptions={this.loadSearchOptions}
            dateLabel="From Date"
            dateVal={this.state.filterFrom}
            onDateChange={this.onFromDateChange}
            dropdownLabel="Station"
            dropdownPlaceholder="Station"
            dropdownVal={this.state.selectedStation}
            onDropdownChange={this.onStationChange}
            dropdownByElementId
            dropdownOptions={this.props.stationsList.stations.results}
            dropdownLabel2="Brand"
            dropdownPlaceholder2="Brand"
            dropdownVal2={this.state.selectedBrand}
            onDropdownChange2={this.onBrandChange}
            dropdownByElementId2
            dropdownOptions2={this.props.brandsList.brands.results}
            searchLabel3="Plant"
            searchPlaceholder3="Search by plant"
            searchVal3={this.state.selectedPlant}
            onSearchChange3={this.onPlantChange}
            searchLabel4="Lot"
            searchPlaceholder4="Search by lot"
            searchVal4={this.state.selectedLot}
            onSearchChange4={this.onLotChange}
            dropdownLabel3="Current location"
            dropdownPlaceholder3="All locations"
            dropdownVal3={this.state.selectedLocation}
            onDropdownChange3={this.onLocationChange}
            dropdownByElementId3
            dropdownOptions3={this.props.locationsList.locations}
            dropdownLabel4="Grade"
            dropdownPlaceholder4="All grades"
            dropdownVal4={this.state.selectedGrade}
            onDropdownChange4={this.onGradeChange}
            dropdownByElementId4
            dropdownOptions4={this.props.gradesList.grades.results}
            colClass="col-12 col-sm-3"
          />
        </div>

        <div className="card">
          <div className="card-block p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Item</th>
                  <th className="hidden-xs-down">Station</th>
                  <th className="hidden-xs-down">Current Location</th>
                  <th>Grade</th>
                  <th className="hidden-xs-down">Brand</th>
                  <th>Qty</th>
                  <th className="hidden-xxs-down">Pieces</th>
                  <th className="hidden-xs-down">Date Received</th>
                </tr>
              </thead>
              <InventoryList inventories={this.props.inventoryList}/>
            </table>
            {this.props.inventoryList.pages > 1 &&
              <ReactPaginate  pageCount={this.props.inventoryList.pages}
                              pageRangeDisplayed={2}
                              marginPagesDisplayed={1}
                              previousLabel="<"
                              nextLabel=">"
                              onPageChange={this.handlePageRequest}
                              initialPage={this.state.currentPage-1}
                              disableInitialCallback={true}
                              containerClassName="pagination"
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              activeClassName="page-item active"
                              previousClassName="paginate_button previous"
                              nextClassName="paginate_button next"
                              disabledClassName="page-item disabled"
                              forcePage={this.state.currentPage-1}/>
            }
          </div>
        </div>
        { this.props.inventoryList.loading || this.state.isLoading || this.props.gradesList.loading ||
          this.props.stationsList.loading || this.props.brandsList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryList: state.reports.inventoryList,
    stationsList: state.sessions.stationsList,
    brandsList: state.inventories.brandsList,
    locationsList: state.inventories.locationsList,
    gradesList: state.inventories.gradesList,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventories: (page, item, station, brand, fromDate, plant, lot, location, grade) => {
      dispatch(fetchInventories(page, true, item, station, brand, undefined, fromDate, plant, lot, location, grade)).payload.then((response) => {
        dispatch(fetchInventoriesSuccess(response.data))
      }, (error) => {
        dispatch(fetchInventoriesFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchBrands: () => {
      dispatch(fetchBrands()).payload.then((response) => {
        dispatch(fetchBrandsSuccess(response.data))
      }, (error) => {
        dispatch(fetchBrandsFailure(error));
      });
    },
    fetchLocations: () => {
      dispatch(fetchLocations()).payload.then((response) => {
        dispatch(fetchLocationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchLocationsFailure(error));
      });
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then((response) => {
        dispatch(fetchGradesSuccess(response.data))
      }, (error) => {
        dispatch(fetchGradesFailure(error));
      });
    },

  };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryListContainer));
